/* Plasmito: Twitch username cart attribute (validation + save). Loaded globally from layout/theme.liquid so it also works when the field appears after an AJAX add-to-cart. See snippets/pl-twitch-attribute.liquid */
(() => {
  if (window.plTwitchAttrInit) return;
  window.plTwitchAttrInit = true;
  const SEL = '[data-pl-twitch-attr]';
  const ATTR = 'Twitch username';
  const RE = /^@?[A-Za-z0-9_]{4,25}$/;
  const state = { value: null, timer: null, saving: null, saved: null };
  const clean = (v) => (v || '').trim().replace(/^@/, '');
  const isValid = (input) => {
    const v = input.value.trim();
    if (v === '') return !input.hasAttribute('data-required');
    return RE.test(v);
  };
  const showError = (input, on) => {
    input.setAttribute('aria-invalid', on ? 'true' : 'false');
    const err = document.getElementById(input.id + '-error');
    if (err) err.hidden = !on;
  };
  const save = (value) => {
    clearTimeout(state.timer);
    if (value === state.saved) return state.saving || Promise.resolve();
    const url = (window.routes && window.routes.cart_update_url) || '/cart/update';
    state.saving = fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { [ATTR]: value } }),
    })
      .then((r) => {
        if (!r.ok) throw new Error(r.status);
        state.saved = value;
      })
      .catch(() => {});
    return state.saving;
  };
  const sync = (source) => {
    state.value = source.value;
    document.querySelectorAll(SEL).forEach((el) => {
      if (el !== source && el.value !== source.value) el.value = source.value;
    });
  };
  document.addEventListener('input', (e) => {
    const input = e.target.closest && e.target.closest(SEL);
    if (!input) return;
    sync(input);
    if (input.getAttribute('aria-invalid') === 'true' && isValid(input)) showError(input, false);
    clearTimeout(state.timer);
    if (isValid(input)) state.timer = setTimeout(() => save(clean(input.value)), 600);
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest && e.target.closest(SEL);
    if (!input) return;
    if (isValid(input)) {
      input.value = clean(input.value);
      sync(input);
      showError(input, false);
      save(input.value);
    } else {
      showError(input, true);
    }
  });
  document.addEventListener('keydown', (e) => {
    const input = e.key === 'Enter' && e.target.closest && e.target.closest(SEL);
    if (!input) return;
    e.preventDefault();
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener(
    'submit',
    (e) => {
      const btn = e.submitter;
      if (!btn || btn.name !== 'checkout') return;
      const form = e.target;
      if (form.dataset.plTwitchOk === 'true') {
        delete form.dataset.plTwitchOk;
        return;
      }
      const input = document.querySelector(SEL + '[form="' + form.id + '"]');
      if (!input) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!isValid(input)) {
        showError(input, true);
        input.focus();
        return;
      }
      input.value = clean(input.value);
      sync(input);
      showError(input, false);
      btn.setAttribute('aria-busy', 'true');
      save(input.value).then(() => {
        btn.removeAttribute('aria-busy');
        form.dataset.plTwitchOk = 'true';
        if (form.requestSubmit) form.requestSubmit(btn);
        else form.submit();
      });
    },
    true
  );
  const restore = () => {
    if (state.value === null) return;
    document.querySelectorAll(SEL).forEach((el) => {
      if (el !== document.activeElement && el.value !== state.value) el.value = state.value;
    });
  };
  const observe = () => {
    document.querySelectorAll('cart-drawer, #main-cart-footer').forEach((root) => {
      if (root.dataset.plTwitchObs) return;
      root.dataset.plTwitchObs = 'true';
      new MutationObserver(restore).observe(root, { childList: true, subtree: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe);
  else observe();
  document.addEventListener('shopify:section:load', observe);
})();
